import Vue from "vue"
import Router from "vue-router"
import Inicio from "@/components/Inicio"
import cursoDav from "@/components/screens/00-davivienda/davivienda"
import Styleguide from "@/components/ui/Styleguide"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "inicio",
      component: Inicio
    },
    {
      path: "/admin-dinero/:unipage",
      component: cursoDav
    },
    {
      path: "/styleguide",
      component: Styleguide
    }
  ]
})



// WEBPACK FOOTER //
// ./src/js/router/index.js